import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const Section = ({ colourScheme, className, children, customPadding, sectionId }) => {
  const componentClasses = classNames('section', {
    [`section--${colourScheme}-scheme`]: colourScheme,
    [className]: className,
    'section--no-padding-top': customPadding === 'no-top',
    'section--no-padding-bottom': customPadding === 'no-bottom',
    'section--no-padding-top-bottom': customPadding === 'no-padding'
  });

  return (
    <section id={sectionId} className={componentClasses}>
      {children}
    </section>
  );
};

Section.propTypes = {
  colourScheme: PropTypes.oneOf([
    'grey',
    'dark-navy',
    'light-grey',
    'gradient',
    'neutral-navy',
    'sand',
    'neutral-teal',
    'dark-teal'
  ]),
  customPadding: PropTypes.oneOf(['no-top', 'no-bottom', 'no-padding']),
  className: PropTypes.string,
  children: PropTypes.node,
  sectionId: PropTypes.string
};

// TODO: Actually have top-level typography
const Title = ({ children, level }) => (
  <h3 className={`section__title${level ? ` section__title--level-${level}` : ''}`}>{children}</h3>
);
Section.Title = Title;

const Subtitle = ({ children }) => <p className="section__subtitle">{children}</p>;
Section.Subtitle = Subtitle;

export default Section;
